import {
	TApiBusinessAdmin,
	TApiBusinessAdminForm,
} from '@modules/TeamMembers/types';
import { ApiRequest } from '@zeal/zeal-lib';

import { ENDPOINTS } from '../endpoints';

export async function apiBusinessAdmins({ queryKey: [, filters] }: any) {
	return new ApiRequest(ENDPOINTS.teamsMembers.admins.list)
		.addHeader('Accept', 'application/json')
		.addHeader('Content-type', 'application/json')
		.addQuery('page', filters?.page)
		.addQuery('role_id', filters?.roleId)
		.addQuery('unassigned', filters?.unassigned)
		.GET<ApiResponseWithPagination<TApiBusinessAdmin>>()
		.then((payload) => ({
			data: payload?.data,
			pageNum: payload?.meta.current_page,
			pagesCount: payload?.meta.last_page || 1,
			total: payload?.meta.total,
		}));
}

export async function apiShowBusinessAdmin({ queryKey: [, filters] }: any) {
	return new ApiRequest(ENDPOINTS.teamsMembers.admins.show(filters?.adminId))
		.addHeader('Accept', 'application/json')
		.addHeader('Content-type', 'application/json')
		.GET();
}

export async function apiAddBusinessAdmin({
	...payload
}: TApiBusinessAdminForm) {
	const { branches, all_branches, roles, ...rest } = payload;
	const mappedBranches =
		all_branches !== 'all' && branches
			? Object.keys(branches)?.filter((key) => branches[key])
			: [];

	const mappedRoles = Object.keys(roles).filter((key) => roles[key]);

	return new ApiRequest(ENDPOINTS.teamsMembers.admins.add)
		.addHeader('Accept', 'application/json')
		.addHeader('Content-type', 'application/json')
		.POST(
			JSON.stringify({
				...rest,
				branch_uuids: mappedBranches,
				all_branches: all_branches === 'all',
				roles: mappedRoles,
			})
		);
}

export async function apiEditBusinessAdmin({
	...payload
}: TApiBusinessAdminForm) {
	const { branches, all_branches, roles, ...rest } = payload;
	const mappedBranches =
		all_branches !== 'all' && branches
			? Object.keys(branches)?.filter((key) => branches[key])
			: [];

	const mappedRoles = Object.keys(roles).filter((key) => roles[key]);

	return new ApiRequest(ENDPOINTS.teamsMembers.admins.show(payload?.uuid ?? ''))
		.addHeader('Accept', 'application/json')
		.addHeader('Content-type', 'application/json')
		.PUT(
			JSON.stringify({
				...rest,
				branch_uuids: mappedBranches,
				all_branches: all_branches === 'all',
				roles: mappedRoles,
			})
		);
}

export async function apiDeleteBusinessAdmin({ ...payload }: any) {
	return new ApiRequest(ENDPOINTS.teamsMembers.admins.show(payload?.uuid ?? ''))
		.addHeader('Accept', 'application/json')
		.addHeader('Content-type', 'application/json')
		.DELETE();
}
